import { useTranslation } from 'react-i18next';

export const HeadlessCaptureStandby = () => {
  const { t } = useTranslation();
  return <>{t('STANDING_BY')}</>;
};
